<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import axios from 'axios';
import moment from "moment";
import DataTable from "@/components/DataTable.vue";


export default {
  page: {
    title: "Shop Purchases Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      filterPurchases: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: '',
        branch_id: 0,
        title: 'Shop Purchases Report'
      },
      title: "Shop Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Shop Purchases Report",
          active: true,
        },
      ],
      serverPerPage: 50,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsPurchaseReportDataServerPaginated:true,
      filter: null,
      sortDesc: false,
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("purchase", [
      "SaveStatus",
      "PurchaseReportData",
      "PurchaseReportDataPagination",
      "PurchaseReportDataSummary",
      "PurchaseReportDataPaginated"
    ]),
    ...mapGetters("setting", ["PaymentOptions","GeneralSettings"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["branchid", "Branches"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unitPrice",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "purchase.date",
          sortable: true,
          label: "DATE",
        }
      ];

      if (this.branchid==0) {
        baseFields.splice(6, 0,
          {
            key: "branch",
            sortable: true,
            label: "BRANCH",
          }       
        );
      }

      if (this.GeneralSettings && this.GeneralSettings.allow_multiple_productcodes) {
        baseFields.splice(2, 0,
          {
            key: "product_code",
            sortable: true,
            label: "PRODUCT CODE(S)",
          },        
        );
      }
      return baseFields;
    },

    rows() {
      return this.IsPurchaseReportDataServerPaginated
        ? this.PurchaseReportDataPagination?.total
        : this.PurchaseReportData
        ? this.PurchaseReportData.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsPurchaseReportDataServerPaginated) {
          return (
            this.PurchaseReportDataPagination.per_page ||
            this.filterPurchases.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsPurchaseReportDataServerPaginated) {
          this.filterPurchases.per_page = value;
          this.filterPurchases.page = 1;
          this.FetchPurchasesReportData(this.filterPurchases);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.PurchaseReportDataPaginated && this.PurchaseReportDataPagination
          ? this.PurchaseReportDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.PurchaseReportDataPaginated) {
          this.filterPurchases.page = value;
          this.handlePageChange(value);
        }
      },
    },

    total_amount() {
      return this.PurchaseReportDataSummary ? this.PurchaseReportDataSummary.totalAmount : 0;
    }
  },

  methods: {
    ...mapActions({
      FetchPurchasesReportData: "purchase/fetchPurchasesReportData",
      FetchModes: "setting/fetchPaymentOptions",
      FetchProducts: "products/fetchProducts",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),


    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    PurchasesReportData() {
      let payload = { ...this.filterPurchases };
      payload.page = this.currentPage;
      payload.per_page = this.serverPerPage;
      this.FetchPurchasesReportData(payload);
    },


    Excel_export() {
      axios
          .post("export_shoppurchases", this.filterPurchases, {
            responseType: "arraybuffer",
          })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "purchases_report.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.spinner = false;
          }).catch(() => {
      });
    },

    handlePageChange(newPage) {
      if (this.IsPurchaseReportDataServerPaginated) {
        this.filterPurchases.page = newPage;
        this.FetchPurchasesReportData(this.filterPurchases);
      }
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  
  created() {
    this.PurchasesReportData();
    this.FetchModes();
    this.FetchProducts();
    this.FetchBranches();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="filterPurchases.title"></h3>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                    :list="Branches ? [ { id: 0, name: 'All Branches' }, ...Branches ] : []"
                    v-model="filterPurchases.branch_id"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Branch"
                    @input="PurchasesReportData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"
                ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                    type="date"
                    v-model="filterPurchases.datefrom"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                    v-model="filterPurchases.dateto"
                    type="date"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>

                <model-list-select
                    :list="Products ? [ { id: '', name: 'All Products' }, ...Products ] : []"
                    v-model="filterPurchases.product"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Product"
                    @input="PurchasesReportData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary cursor-pointer" type="button" @click="PurchasesReportData()">
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                      v-show="SaveStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <div>
                <DataTable
                  :columns="fields"
                  :rows="PurchaseReportData || []"
                  :total-rows="rows"
                  :pagination="PurchaseReportDataPagination"
                  :server-pagination="IsPurchaseReportDataServerPaginated"
                  :loading="SaveStatus"
                  >
                  <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                  </template>
                    <template #cell(product) ="{row}">{{ row.product }}</template>
                    <template v-if="GeneralSettings.allow_multiple_productcodes" #cell(product_code) ="{row}">{{ row.product_code }}</template>
                    <template #cell(qty) ="{row}">{{ row.qty }}</template>
                    <template #cell(unitPrice) ="{row}">{{ thousandSeperator(row.unitPrice) }}</template>
                    <template #cell(cell) ="{row}">{{ thousandSeperator(row.total) }}</template>
                    <template #cell(purchase.date) ="{row}">{{ row.purchase ? row.purchase.date : 'N/A' }}</template>
                    <template #cell(branch) ="{row}" v-if="branchid==0">{{ row.branch }}</template>
                </DataTable>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
